module.exports = __webpack_public_path__ + "img/ic_launcher@3x.50a3c9e0.png";